function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTealCarIssue = function SvgTealCarIssue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M33.99 21.728 31.163 18.9a4 4 0 0 0-5.656 0l-14.85 14.849a4 4 0 0 0 0 5.657l2.829 2.828a4 4 0 0 0 5.657 0L33.99 27.385a4 4 0 0 0 0-5.657Z",
    style: {
      stroke: "var(--accent-teal)"
    },
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.95 34.456 15.91-15.91-7.656-3.96a4 4 0 0 0-4.666.725l-7.085 7.085a4 4 0 0 0-.645 4.813l4.141 7.247Z",
    style: {
      stroke: "var(--accent-teal)"
    },
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.406 30.214a1.5 1.5 0 1 0 2.12-2.12l-2.12 2.12ZM32.93 27.74l2.475 2.474 2.12-2.12-2.474-2.476-2.121 2.122Z",
    style: {
      fill: "var(--accent-teal)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.063 9.001 8.485 8.485M41.063 17.485 49.547 9",
    style: {
      stroke: "var(--accent-teal)"
    },
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.849 45.064a1.5 1.5 0 1 0 2.121-2.121l-2.121 2.121Zm-2.475-2.475 2.475 2.475 2.121-2.121-2.475-2.475-2.121 2.121Z",
    style: {
      fill: "var(--accent-teal)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 44.563h45.255",
    style: {
      stroke: "var(--accent-teal)"
    },
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.273 25.619a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122ZM15.253 37.638a1.5 1.5 0 1 0 2.121-2.121 1.5 1.5 0 0 0-2.121 2.121Z",
    style: {
      fill: "var(--accent-teal)",
      stroke: "var(--accent-teal)"
    }
  }));
};
export default SvgTealCarIssue;